import {
  FactoryVerificationStep,
  LocationEvidence,
  LocationEvidenceRole,
} from '@/types/LocationVerification.type';

export type PendingVerificationCapture = {
  clientEvidenceId: string;
  role: LocationEvidenceRole;
  previewUrl: string;
};

export type FactoryVerificationPhotoGridItem =
  | { kind: 'saved'; evidence: LocationEvidence }
  | { kind: 'pending'; capture: PendingVerificationCapture };

export function isFactoryVerificationRoomStep(
  step: FactoryVerificationStep,
  stepParam?: string
): boolean {
  return step === 'room' || stepParam === 'room';
}

export function buildFactoryVerificationPhotoGridItems(params: {
  step: FactoryVerificationStep;
  visibleEntranceEvidence: LocationEvidence[];
  visibleRoomEvidence: LocationEvidence[];
  pendingCaptures: PendingVerificationCapture[];
  maxPhotos: number;
}): FactoryVerificationPhotoGridItem[] {
  const { step, visibleEntranceEvidence, visibleRoomEvidence, pendingCaptures, maxPhotos } = params;
  const pendingEntrance = pendingCaptures
    .filter((item) => item.role === 'ENTRANCE')
    .map((capture) => ({ kind: 'pending' as const, capture }));
  const pendingRoom = pendingCaptures
    .filter((item) => item.role === 'INSPECTION_ROOM')
    .map((capture) => ({ kind: 'pending' as const, capture }));
  if (step === 'room' || step === 'complete') {
    const savedItems: FactoryVerificationPhotoGridItem[] = visibleRoomEvidence
      .slice(0, maxPhotos)
      .map((evidence) => ({
        kind: 'saved' as const,
        evidence,
      }));
    return [...savedItems, ...pendingRoom];
  }
  if (step === 'saved' || step === 'entrance') {
    const savedItems: FactoryVerificationPhotoGridItem[] = visibleEntranceEvidence
      .slice(0, maxPhotos)
      .map((evidence) => ({ kind: 'saved' as const, evidence }));
    return [...savedItems, ...pendingEntrance];
  }
  return [];
}

export function countPendingCapturesByRole(
  pendingCaptures: PendingVerificationCapture[],
  role: LocationEvidenceRole
): number {
  return pendingCaptures.filter((item) => item.role === role).length;
}
